import { ROLES_LIST } from '@/js/constants';
export default [{
  name: 'Data Governances Actions',
  icon: 'mdi-account-cog',
  key: 'menu.config.data_governance',
  subname: '',
  roles: [ROLES_LIST.ORG_DATA_STEWARD, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ATTRIBUTE_ADMIN, ROLES_LIST.INSIGHTS_ADMIN, ROLES_LIST.SERVICE_MANAGER, ROLES_LIST.INSIGHTS_SERVICE_MANAGER, "support_developer"],
  subItems: [{
    name: 'Roles & Usuarios',
    key: 'menu.config.roles',
    href: {
      name: 'DataGovernanceRoles'
    },
    link: '/DataGovernanceRoles',
    roles: [ROLES_LIST.ORG_DATA_STEWARD, ROLES_LIST.AUDIENCE_ANALYST, ROLES_LIST.AUDIENCE_ADMIN, ROLES_LIST.ATTRIBUTE_ADMIN, ROLES_LIST.ATTRIBUTE_SUPERVISOR, ROLES_LIST.INSIGHTS_ADMIN, ROLES_LIST.SERVICE_MANAGER, ROLES_LIST.INSIGHTS_SERVICE_MANAGER, "support_developer"]
  }, {
    name: 'Business Domains',
    key: 'menu.config.business_domains',
    href: {
      name: 'BusinessDomain'
    },
    link: '/BusinessDomain',
    roles: [ROLES_LIST.ORG_DATA_STEWARD]
  }, {
    name: 'Log de accesos',
    key: 'menu.config.log',
    href: {
      name: 'LogAccess'
    },
    link: '/LogAccess',
    roles: [ROLES_LIST.ORG_DATA_STEWARD]
  }]
}, {
  name: 'Platform Maintenance',
  icon: 'icon-config',
  key: 'menu.config.maintenance',
  checkDomain: true,
  subItems: [{
    name: 'Organization maintenance',
    icon: 'icon-audiences',
    key: 'menu.config.domain_maintenance',
    subname: '',
    href: {
      name: 'DomainMaintenance'
    },
    link: '/DomainMaintenance',
    checkDomain: true,
    roles: [ROLES_LIST.ORG_DATA_STEWARD, "support_developer"]
  }, {
    name: 'Settings',
    icon: 'icon-audiences',
    key: 'menu.config.settings',
    subname: '',
    href: {
      name: 'Settings'
    },
    link: '/Settings',
    checkDomain: true,
    roles: ["support_developer"]
  }, {
    name: 'Whitelist maintenance',
    icon: 'icon-audiences',
    key: 'menu.config.whitelist_maintenance',
    subname: '',
    checkDomain: true,
    href: {
      name: 'WhitelistMaintenance'
    },
    link: '/WhitelistMaintenance',
    roles: [ROLES_LIST.ORG_DATA_STEWARD, "support_developer"]
  }]
}];